<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back">
        <mat-icon color="primary">arrow_back_ios</mat-icon>
    </button>
    <h3>{{ patient | patientHeading:'Consent' }}</h3>
    <div>
        <button mat-icon-button *ngIf="editingConsent && editingConsent.id" (click)="deleteConsent()"
            matTooltip="Delete Consent">
            <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!stateMode" [disabled]="!form.get('consentType')?.value" [matMenuTriggerFor]="emailMenu"
            [matTooltip]="'Send Selected Consent'">
            <mat-icon [color]="!form.get('consentType')?.value ? '' : 'primary'">send</mat-icon>
        </button>
        <mat-menu #emailMenu="matMenu" class="p-10">
            <div mat-menu-content (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline" class="full-width">
                    <input matInput [(ngModel)]="patient.email">
                    <button matSuffix mat-icon-button (click)="sendConsent()" matTooltip="Send to this email address">
                        <mat-icon>send</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </mat-menu>
        <button mat-icon-button [disabled]="form.invalid" (click)="saveConsent()" matTooltip="Save Consent">
            <mat-icon [color]="form.invalid ? '' : 'primary'">save</mat-icon>
        </button>

    </div>
</mat-toolbar>

<div class="consent-details-container">
    <mat-card>
        <form [formGroup]="form">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="dateDatePicker" formControlName="date" placeholder="DD/MM/YYYY"
                    [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dateDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Requesting Physician</mat-label>
                <mat-select formControlName="physicianId">
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">{{user.title}} {{user.name}}
                        {{user.surname}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Consent Type</mat-label>
                <mat-select formControlName="consentType" (selectionChange)="selectConsentType($event)">
                    <mat-option *ngFor="let consentType of consentTypes" [value]="consentType">
                        {{ consentType.label }} {{consentType.consentType ==='interactive' ? ' (Interactive AI)':'' }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </form>


        <ng-container *ngIf="selectedConsentForm?.text">

            <ng-container *ngIf="selectedConsentForm.consentType === 'interactive'">

                <mat-form-field *ngIf="eligibleAiRequestsForConsent.length" appearance="outline" class="full-width">
                    <mat-label>Copy details from AI request</mat-label>
                    <mat-select [(ngModel)]="selectedAiRequestIdForConsent"
                        (ngModelChange)="onSelectedAiRequestForConsentChange($event)">
                        <mat-option *ngFor="let req of eligibleAiRequestsForConsent" [value]="req.id">
                            {{ req.suggestedNoteTitle || 'AI Encounter' }} — {{ req.createdAt | date: 'dd/MM/yyyy' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Procedure Title</mat-label>
                    <input matInput [(ngModel)]="selectedConsentForm.procedureTitle" placeholder="Procedure Title"
                        type="text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Condition</mat-label>
                    <input matInput [(ngModel)]="selectedConsentForm.conditionText" placeholder="Condition" type="text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Highlighted Risks</mat-label>
                    <textarea matInput [(ngModel)]="selectedConsentForm.specificRisksText" rows="4"></textarea>
                </mat-form-field>

                <h3><strong>CONSENT FOR {{selectedConsentForm.procedureTitle}}</strong></h3>
                <div [innerText]="selectedConsentForm.condition + selectedConsentForm.conditionText"
                    class="preserve-line-breaks"></div><br>
                <div [innerText]="selectedConsentForm.treatment + selectedConsentForm.procedureTitle"
                    class="preserve-line-breaks"></div><br>
                <div [innerText]="selectedConsentForm.generalRisks" class="preserve-line-breaks"></div><br>
                <div [innerText]="selectedConsentForm.specificRisks + selectedConsentForm.specificRisksText"
                    class="preserve-line-breaks"></div><br>
                <div [innerText]="selectedConsentForm.text" class="preserve-line-breaks"></div><br>
            </ng-container>

            <ng-container *ngIf="selectedConsentForm.consentType === 'standard'">
                <div [innerText]="selectedConsentForm.text" class="preserve-line-breaks"></div>
            </ng-container>

            <ng-container *ngIf="selectedConsentForm.confirmSide && selectedConsentForm.sideOptions?.length">
                <mat-form-field appearance="outline" class="m-t-20 full-width">
                    <mat-label>Procedure Side</mat-label>
                    <mat-select [(ngModel)]="selectedConsentForm.selectedProcedureSide" required>
                        <mat-option *ngFor="let option of selectedConsentForm.sideOptions" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>


            <ng-container *ngIf="selectedConsentForm.confirmImplant && selectedConsentForm.implantOptions.length">
                <mat-form-field appearance="outline" class="m-t-20 full-width">
                    <mat-label>Implant</mat-label>
                    <mat-select [(ngModel)]="selectedConsentForm.selectedImplant" required>
                        <mat-option *ngFor="let option of selectedConsentForm.implantOptions" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>

            <ng-container
                *ngIf="selectedConsentForm.confirmTransfusion && selectedConsentForm.transfusionOptions.length">
                <mat-form-field appearance="outline" class="m-t-20 full-width">
                    <mat-label>Blood Transfusion</mat-label>
                    <mat-select [(ngModel)]="selectedConsentForm.selectedTransfusion" required>
                        <mat-option *ngFor="let option of selectedConsentForm.transfusionOptions" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>


            <ng-container *ngIf="selectedConsentForm.additionalRequiredConsent?.length">
                <div class="field-column">
                    <h3 class="p-t-10">REQUIRED CONSENT</h3>
                    <p><strong>I Consent to the following:</strong></p>
                    <mat-radio-group [(ngModel)]="selectedConsentForm.selectedRequiredConsent">
                        <mat-radio-button *ngFor="let consent of selectedConsentForm.additionalRequiredConsent"
                            [value]="consent">
                            {{ consent }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedConsentForm.conditionalConsent?.length">
                <h3 class="p-t-10">OPTIONAL CONSENT</h3>
                <p><strong>I Consent to the following:</strong></p>
                <mat-checkbox *ngFor="let consent of selectedConsentForm.conditionalConsent"
                    [(ngModel)]="consent.consentGiven">{{
                    consent.name }}</mat-checkbox>
            </ng-container>

            <ng-container *ngIf="selectedConsentForm.informationSheets?.length">
                <h3 class="p-t-10">INFORMATION SHEETS</h3>
                <ng-container *ngIf="!stateMode">
                    <mat-checkbox *ngFor="let sheet of selectedConsentForm.informationSheets"
                        [(ngModel)]="sheet.sendSheet"><a [href]="sheet.mediaUrl" target="_blank"
                            matTooltip="Download information sheet">{{sheet.name }}</a>
                    </mat-checkbox>
                </ng-container>
                <!-- A state unit sends nothing: the sheets are downloads only. -->
                <ng-container *ngIf="stateMode">
                    <p *ngFor="let sheet of selectedConsentForm.informationSheets"><a [href]="sheet.mediaUrl" target="_blank"
                            matTooltip="Download information sheet">{{sheet.name }}</a></p>
                </ng-container>
            </ng-container>

            <!--
              §29 — THE PRACTICE'S DOCUMENTS, ON THE SCREEN THAT ACTUALLY SENDS A CONSENT REQUEST.

              The picker was built in 2.5b and wired into `patient-consent-dialog`, which is the
              "Pending Consent Detected" INTERRUPT dialog — not a screen anybody navigates to. This
              page, `add-consent` / `edit-consent/:id`, is the one reached from "Add Patient
              Consent", and it never had it. That is why the owner could not find it.

              It sits BESIDE the information sheets above rather than replacing them: §14.6
              decision 2 retires those into this picker later, and the two coexist until it does.

              It hides itself when the practice has no documents, so a practice that has never
              uploaded one sees nothing new here.
            -->
            <app-document-attachment-picker *ngIf="!stateMode" context="consentRequest" [patientId]="patient?.id"
                [groupId]="patient?.groupId" [selection]="selectedDocumentIds"
                label="Documents to send with this request"
                (selectionChange)="selectedDocumentIds = $event"
                data-test="consent-detail-document-picker">
            </app-document-attachment-picker>


            <div class="signature-pad-container m-t-5" *ngIf="!editingConsent">
                <div class="signature-pad">
                    <app-signature-pad [emitOnDragEnd]="true" format="base64" (done)="getSignatureData($event)"
                        (cleared)="getSignatureData('')" [signatoryRequired]="true">
                    </app-signature-pad>
                </div>
            </div>
        </ng-container>

        <app-file-gallery *ngIf="editingConsent" [fileObjects]="editingConsent.media"
            [deleteEnabled]="false"></app-file-gallery>
    </mat-card>

    <div class="mobile-spacer"></div>
</div>